import React from "react";
import PropTypes from "prop-types";
import { Input } from "@xo-union/ui-form-validations";
const wrapComponent = Component => {
  const WithValidation = /*#__PURE__*/React.forwardRef((props, ref) => {
    const {
      name,
      defaultValue,
      value,
      validations,
      onBlur,
      onChange,
      subText,
      subTextOnValid,
      subTextOnInvalid,
      state,
      ...restOfProps
    } = props;
    return /*#__PURE__*/React.createElement(Input, {
      ref: ref,
      name: name,
      value: value,
      defaultValue: defaultValue,
      onBlur: onBlur,
      onChange: onChange,
      subText: subText,
      subTextOnValid: subTextOnValid,
      subTextOnInvalid: subTextOnInvalid,
      state: state,
      validations: validations
    }, (validationProps, data) => {
      const finalProps = {
        ...restOfProps,
        ...validationProps,
        state: data.state,
        subText: data.subText
      };
      return /*#__PURE__*/React.createElement(Component, finalProps);
    });
  });
  WithValidation.displayName = `WithValidation(${Component.displayName || Component.name || 'Component'})`;
  process.env.NODE_ENV !== "production" ? WithValidation.propTypes = {
    name: PropTypes.string,
    defaultValue: PropTypes.string,
    value: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    validations: PropTypes.any,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    subText: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    subTextOnValid: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    subTextOnInvalid: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    state: PropTypes.string
  } : void 0;
  return WithValidation;
};
export default wrapComponent;